module.exports = __webpack_public_path__ + "static/media/garlic_farmer_framed1.10229e07.png";